import { defaultLanguage } from "@/lib/data/languages";
import {
  getInitialLanguageKey,
  getLanguageSettings,
} from "@/lib/helpers/language.helpers";
import {
  LanguageContext,
  LanguageKeyType,
  LanguageProviderPropsType,
} from "@/lib/main";
import { useLayoutEffect, useState } from "react";

const LanguageProvider: React.FC<LanguageProviderPropsType> = ({
  children,
}) => {
  const initialLanguageKey = getInitialLanguageKey();

  const [language, setLanguage] = useState<LanguageKeyType>(initialLanguageKey);

  const settings = getLanguageSettings(language);

  const htmlLanguage = settings?.htmlLanguage ?? defaultLanguage.htmlLanguage;
  const textDirection =
    settings?.textDirection ?? defaultLanguage.textDirection;

  const toggleLanguage = () => {
    const toggledLanguage = language === "ar" ? "en" : "ar";
    setLanguage(toggledLanguage);
  };

  useLayoutEffect(() => {
    localStorage.setItem("language", language);

    document.body.classList.remove("arabic-font", "rtl", "english-font", "ltr");

    if (language === "ar") {
      document.body.classList.add("arabic-font", "rtl");
      document.documentElement.lang = "ar-EG";
      document.documentElement.dir = "rtl";
    } else {
      document.body.classList.add("english-font", "ltr");
      document.documentElement.lang = "en-US";
      document.documentElement.dir = "ltr";
    }
  }, [language]);

  const value = {
    language,
    setLanguage,
    htmlLanguage,
    textDirection,
    toggleLanguage,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
